export class Cookies {
    past = new Date(0);

    set(name: string, value?: null | string | number) {
        const type = typeof value;
        if (type === 'string' || type === 'number') {
            const domain = window.location.hostname.replace("www.", "");
            document.cookie = `${name}=${value}; path=/; domain=.${domain}`;
        } else {
            this.remove(name);
        }
    }

    get(name: string) {
        return this.readAll().get(name) ?? null;
    }

    remove(name: string) {
        document.cookie = `${name}=; path=/; expires=${this.past.toUTCString()};`;
    }

    readAll() {
        const list = document.cookie.split(';');
        const pairs = list.map(cookie => cookie.trim().split('=') as [string, string]);
        const map = new Map<string, string>(pairs);

        return map;
    }
}